/**
 * Shows the success message a page left in router state (see `flashState`)
 * once the user lands on the destination.
 *
 * The flash is then dropped from the history entry so a refresh or a back
 * navigation does not replay it. "/" is skipped: it only redirects to the
 * landing page, and `LandingRedirect` forwards the state there.
 */
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { SuccessToast } from "@/ui/molecules";
import { readFlash } from "@/ui/router";

export function FlashToast() {
    const location = useLocation();
    const navigate = useNavigate();
    const [message, setMessage] = useState<string | null>(null);

    useEffect(() => {
        const flash = readFlash(location.state);
        if (!flash || location.pathname === "/") return;
        setMessage(flash);
        navigate(
            { pathname: location.pathname, search: location.search, hash: location.hash },
            { replace: true, state: null },
        );
    }, [location, navigate]);

    if (!message) return null;
    return <SuccessToast message={message} onDismiss={() => setMessage(null)} />;
}
